<div [class]="{'chip' : true, 'selected' : selected}">
  <span class="chip-text">
    <ng-content></ng-content>
  </span>
  @if (showCross) {
    <div class="close-btn" (click)="cross()">
      <od-svg-icon class="svg-wrapper" name="icon-times" [parentSize]="true"></od-svg-icon>
    </div>
  }
</div>
